import { useEffect, useRef } from 'react';
import { config } from '../config';
import { Publisher, User } from '../shared/types';
import { baseUrls } from './baseUrls.utils';

export const premiumChannelsEnabled = (skipPremiumChannelsFlag = true) => {
    if (!config.premiumChannelsEnabled && skipPremiumChannelsFlag) {
        return config.premiumFeatures;
    }

    return config.premiumChannelsEnabled;
};

export const topicsOrCategories = (
    isMultiple?: boolean,
    isCapitalized?: boolean
) => {
    if (isMultiple && isCapitalized) {
        return premiumChannelsEnabled() ? 'Topics' : 'Categories';
    }

    if (isMultiple) {
        return premiumChannelsEnabled() ? 'topics' : 'categories';
    }

    if (isCapitalized) {
        return premiumChannelsEnabled() ? 'Topic' : 'Category';
    }

    return premiumChannelsEnabled() ? 'topic' : 'category';
};

export function getPublisherUrl(publishedBy: Omit<Publisher, 'name'>) {
    return `${publishedBy.type === 'contributor' ? baseUrls.contributor.main : baseUrls.desk.main}/${encodeURIComponent(publishedBy._id)}`;
}

export enum OSList {
    windows = 'windows',
    macOs = 'macOs',
    unix = 'unix',
    linux = 'linux',
}

export const getOperatingSystem = (window: Window) => {
    let operatingSystem = 'Not known';
    if (window.navigator.appVersion.indexOf('Win') !== -1) {
        operatingSystem = OSList.windows;
    }
    if (window.navigator.appVersion.indexOf('Mac') !== -1) {
        operatingSystem = OSList.macOs;
    }
    if (window.navigator.appVersion.indexOf('X11') !== -1) {
        operatingSystem = OSList.unix;
    }
    if (window.navigator.appVersion.indexOf('Linux') !== -1) {
        operatingSystem = OSList.linux;
    }

    return operatingSystem;
};

export const isWindows = getOperatingSystem(window) === OSList.windows;

export const getFileName = (url: string) => {
    const chunks = url.split('/');

    return chunks[chunks.length - 1];
};

export const usersContains = (
    users: User[],
    target: string
): User | undefined => {
    if (!users || !users.length) return;
    return users.find((c: User) => c._id === target);
};

export function usePrevious<T>(value: T) {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

export const isStringArray = (test: any[]): boolean => {
    return (
        Array.isArray(test) && test.every((value) => typeof value === 'string')
    );
};

export const setBuzzsproutPlayerHeight = () => {
    const buzzsprout = document.querySelectorAll("iframe[src*='buzzsprout']");

    buzzsprout.forEach((i) => {
        i.setAttribute('scrolling', 'no');
        if (i && i.parentElement) i.parentElement.classList.add('buzzsprout');
    });
};

export const formatAnonymousUserData = (data: string): string => {
    return data || 'Anonymous';
};

export const filterClassesForUndefinedValue = (arr: (string | undefined)[]) =>
    arr.filter((n) => !!n).join(' ');

export const randomizeArray = (arr: any[] = []): any[] =>
    arr.sort(() => (Math.random() > 0.5 ? 1 : -1));
export const sliceArray = (arr: any[] = [], quantityToDisplay = 5): any[] =>
    (arr || []).slice(0, quantityToDisplay);
